const Password = () => ({
  /**
   * Whether the password is visible
   */
  showPassword: false,

  get inputType() {
    return this.showPassword ? 'text' : 'password';
  },

  get buttonTitle() {
    return this.showPassword ? 'Hide password' : 'Show password';
  },

  onClickToggle() {
    this.showPassword = !this.showPassword;
  }
});

export default Password;
